import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { AxiosRequestConfig } from 'axios';
import dataRoomApi from '../../dataRoomApi';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { AnswerFile } from '../../models/QAndA';
import RichTextEditorFieldWithFileUpload from 'components/RichTextEditorFieldWithFileUpload';

import './AnswerRichTextEditor.styles.scss';

type AnswerRichTextEditorProps = {
  className?: string;
  label: string;
  richTextEditorName?: string;
  filesName?: string;
  answerId?: string;
  initialFiles?: AnswerFile[];
  onRemoveAnswerFile?: (fileId: string) => void;
};

const AnswerRichTextEditor: React.FC<AnswerRichTextEditorProps> = (props) => {
  const {
    className,
    label,
    answerId,
    richTextEditorName = 'answerContent',
    filesName = 'uploadedFiles',
    initialFiles = [],
    onRemoveAnswerFile,
  } = props;

  const classes = classNames('answer-rich-text-editor', className);

  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  const uploadRequest = useCallback(
    (file: File, config: AxiosRequestConfig) =>
      dataRoomApi.questionsAndAnswers.uploadAnswerFile(
        file,
        dataRoomId,
        config,
      ),
    [dataRoomId],
  );

  const deleteRequest = useCallback(
    async (fileId: string) => {
      if (answerId) {
        await dataRoomApi.questionsAndAnswers.removeAnswerFile(
          answerId,
          fileId,
        );
        onRemoveAnswerFile?.(fileId);
      }
    },
    [answerId, onRemoveAnswerFile],
  );

  return (
    <RichTextEditorFieldWithFileUpload
      className={classes}
      label={label}
      richTextEditorName={richTextEditorName}
      filesName={filesName}
      initialFiles={initialFiles.map(({ _id, file }) => ({ ...file, _id }))}
      onUploadRequest={uploadRequest}
      onDeleteRequest={deleteRequest}
    />
  );
};

export default AnswerRichTextEditor;
